import { useState, type FormEvent } from "react";
import { supabase } from "./supabase.js";

/**
 * Sign-in only, deliberately - this is a single-user pilot, so there's no
 * public sign-up flow to build or secure. Create the account directly in the
 * Supabase dashboard (Authentication > Users > Add user).
 */
export function SignIn() {
  const [pending, setPending] = useState(false);
  const [error, setError] = useState("");

  async function signIn(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    setPending(true);
    setError("");
    const { error: signInError } = await supabase.auth.signInWithPassword({
      email: String(form.get("email")),
      password: String(form.get("password")),
    });
    setPending(false);
    if (signInError) setError(signInError.message);
  }

  return (
    <div className="auth-page">
      <form className="auth-card" onSubmit={(event) => void signIn(event)}>
        <div className="auth-icon">
          <img src="/icon-512.png" alt="Critical Stack Ledger" />
        </div>
        <div className="auth-header">
          <h1>Critical Stack Ledger</h1>
          <p>Receipts & Expense Tracker</p>
        </div>
        {error && (
          <div role="alert" className="alert-error">
            {error}
            <button type="button" onClick={() => setError("")}>✕</button>
          </div>
        )}
        <div className="auth-form">
          <label className="form-label">
            <span>Email address</span>
            <input
              name="email"
              type="email"
              required
              autoFocus
              autoComplete="email"
              placeholder="you@example.com"
            />
          </label>
          <label className="form-label">
            <span>Password</span>
            <input
              name="password"
              type="password"
              required
              autoComplete="current-password"
              placeholder="••••••••"
            />
          </label>
          <button className="primary full-width" type="submit" disabled={pending}>
            {pending ? "Signing in…" : "Sign in"}
          </button>
        </div>
        <div className="auth-footer">
          <p>
            By signing in, you agree to our{" "}
            <a href="/privacy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
          </p>
        </div>
      </form>
    </div>
  );
}
